import { render, staticRenderFns } from "./SettingsThree.vue?vue&type=template&id=07db8acf&scoped=true&"
import script from "./SettingsThree.vue?vue&type=script&lang=js&"
export * from "./SettingsThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07db8acf",
  null
  
)

export default component.exports